import { ArrowUpRight, Plus, Users } from "lucide-react";

import type { GtmBrainDoc } from "../api/GtmApi";
import { listPersonas } from "./personas";

type Props = {
  docs: GtmBrainDoc[];
  onOpenPersona: (key: string) => void;
  onAddPersona: () => void;
  onBackToOverview: () => void;
};

export default function BrainPersonasPanel({
  docs,
  onOpenPersona,
  onAddPersona,
  onBackToOverview,
}: Props) {
  const personas = listPersonas(docs);

  return (
    <div className="flex h-full w-[22rem] shrink-0 flex-col border-r border-slate-200 bg-white">
      <div className="border-b border-slate-100 px-4 py-3 text-xs text-slate-500">
        <button
          type="button"
          className="hover:text-slate-800 hover:underline"
          onClick={onBackToOverview}
        >
          Brain
        </button>
        <span className="mx-1.5 text-slate-300">›</span>
        <span className="font-medium text-slate-800">Personas</span>
      </div>

      <div className="flex-1 overflow-y-auto px-4 py-5">
        <div className="mb-4 flex items-start justify-between gap-2">
          <div>
            <div className="mb-1 flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-violet-50">
                <Users className="h-4 w-4 text-violet-600" />
              </span>
              <h2 className="text-base font-semibold text-slate-900">Personas</h2>
            </div>
            <p className="text-sm text-slate-500">The people you win. One document per persona.</p>
          </div>
          <button
            type="button"
            onClick={onAddPersona}
            className="inline-flex shrink-0 items-center gap-1 rounded-md border border-slate-200 bg-white px-2 py-1.5 text-[11px] font-medium text-slate-700 hover:bg-slate-50"
          >
            <Plus className="h-3.5 w-3.5" />
            Add persona
          </button>
        </div>

        {personas.length === 0 ? (
          <p className="rounded-lg border border-dashed border-slate-200 px-3 py-6 text-center text-sm text-slate-500">
            No personas yet. Add one to start.
          </p>
        ) : (
          <ul className="divide-y divide-slate-100 rounded-lg border border-slate-200">
            {personas.map((p) => (
              <li key={p.key}>
                <button
                  type="button"
                  className="flex w-full items-center gap-3 px-3 py-3.5 text-left transition-colors hover:bg-slate-50"
                  onClick={() => onOpenPersona(p.key)}
                >
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-violet-50 text-base">
                    {p.emoji}
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block truncate text-sm font-medium text-slate-900">
                      {p.label}
                    </span>
                    <span className="mt-0.5 block text-xs text-slate-500">
                      {p.filled} of {p.total} sections filled
                    </span>
                  </span>
                  <ArrowUpRight className="h-4 w-4 shrink-0 text-slate-400" />
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
